import * as React from "react";
import {Grid} from "react-bootstrap";
import {InjectedIntlProps, injectIntl} from "react-intl";
import {ActionBar} from "../common/ui/actionbar/ActionBar";
import {MasterDetailLayout} from "../common/ui/layouts/MasterDetailLayout";
import {AddToServiceButton} from "../services/AddToServiceButton";
import {PublishProductInServiceButton} from "../services/CreateServiceButton";
import {CreateProductButton} from "./CreateProductButton";
import {Product} from "./model";
import {ProductList} from "./ProductList";
import {ProductListDetailSection} from "./ProductListDetailSection";
import {ProductsFilter} from "./ProductsFilter";

interface ProductsPageState {
  selection: Product[];
}

class ProductsPageReactComponent extends React.Component<InjectedIntlProps, ProductsPageState> {
  constructor(props) {
    super(props);
    this.state = {
      selection: [],
    };
  }

  handleRowSelect = (selection: Product[]) => {
    this.setState(Object.assign({}, this.state, {selection}));
  }
  clearSelection = () => this.handleRowSelect([]);
  render() {
    const {selection} = this.state;
    const noSelection = selection.length === 0;

    const masterPane = (
        <Grid fluid={true}>
          <ActionBar>
            <CreateProductButton/>
          </ActionBar>

          <ProductsFilter notifyFilterChanged={this.clearSelection}/>

          <ActionBar>
            <PublishProductInServiceButton disabled={noSelection} inputProducts={selection}/>
            <AddToServiceButton disabled={noSelection} inputProducts={selection}/>
          </ActionBar>

          <div> {/* This empty div is necessary! it's used by ControlRoomTable to calculate its dimensions.*/}
            <ProductList onRowSelect={this.handleRowSelect}
                         clearSelection={noSelection}/>
          </div>
        </Grid>
    );

    const detailPane = <ProductListDetailSection selection={selection}/>;

    return (
        <MasterDetailLayout masterPane={masterPane} detailPane={detailPane}/>
    );
  }
}

export const ProductsPageComponent = ProductsPageReactComponent;
export const ProductsPage = injectIntl(ProductsPageComponent);